import { ConfiguratorFieldDependencyController } from '../configurator-field-dependency-controller';

export class FieldDepencencyController {
  constructor() {
    this.fields = [];
    this.fieldsDependencyController = new ConfiguratorFieldDependencyController();

    Array.from(document.querySelectorAll('.configurator-field')).forEach((e) => {
      var field = JSON.parse(e.innerHTML);
      var controlToHide = document.getElementById(field.controlToHideId);
      var htmlInput = document.getElementById(field.htmlInputId);

      this.fieldsDependencyController.setDependencyOnField({
        field,
        htmlInput,
        controlToHide,
        triggerOnEvent: field.triggerOnEvent,
        getValueCallback: (currentField) => {
          if (field.type === 'TextBox' || field.type === 'TextArea') {
            return document.getElementById(field.htmlInputId).value;
          } else if (field.type === 'FileUpload') {
            return currentField.inputs[0].files.length === 1;
          } else if (field.type === 'CategorizedMultiselector') {
            return currentField.inputs
              .filter((x) => x.checked)
              .map((field) => (!field.dataset.usevaluefromcheckbox ? field.checked : field.value));
          } else if (field.type === 'Checkbox') {
            return !currentField.inputs[0].dataset.usevaluefromcheckbox
              ? currentField.inputs[0].checked.toString()
              : currentField.inputs[0].value;
          } else if (field.type === 'Dropdown') {
            return document.querySelector(`#${currentField.htmlInputId}`).value;
          }
        },
        onVisibilityChange: undefined,
      });
    });
    this.fieldsDependencyController.createDependencyMap();
  }
}
